import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Box,
  Stack,
  Text,
} from '@chakra-ui/react'
import Button from './Button';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
export default function EventModal({ isOpen, onClose, number }) {

  const onlineUser = useSelector((state) => state.onlineUser);
  const apiLink = useSelector((state) => state.apiLink);

  const [Data, setData] = useState('')

  const estateUser = () => {
    fetch(`${apiLink.link}/user/getEstateManager/${onlineUser.user.estateName}`)
      .then(response => response.json())
      .then(data => {

        if (data.status === 200) {
          setData(data.estateManager[data.estateManager.length > 1 ? data.estateManager.length - 1 : 0])

        }

      })
      .catch((error) => {
        console.error('Error:', error);
      });

  }
  const nav = useNavigate()

  useEffect(() => {
    estateUser()
  }, [])

  return (
    <div>
      <Modal motionPreset='slideInBottom' size={"xs"} closeOnOverlayClick={true} isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalCloseButton  onClick={()=>nav("/home")}/>
          <ModalBody>
            <Stack spacing={"19px"}>
              <Box  borderLeft={"7px solid #11C19E"} pl="8px" fontSize={"14px"} fontFamily="body" fontWeight={"300"} color="#424242" >Your multiple visitor access request has been sent to your estate administrator for approval.</Box>
              <Text mt="16px" borderLeft={"7px solid #11C19E"} pl="8px" fontSize={"14px"} fontFamily="body" fontWeight={"300"} color="#424242">
                Estate Admin -<Box as="span" color="#00000" fontWeight={"700"}>{Data?.prefix}. {Data?.lastName || "Support Team"}</Box> <br/>
                Phone No - <Box as="span" fontWeight="700" color={"#1869E1"} textDecor="underline">{Data?.phone || "08068840125"}</Box>
              </Text>
              <Box fontSize={"14px"} fontFamily="body" color="#424242" fontWeight={"300"} borderLeft={"7px solid #11C19E"} pl="8px">You will get a notification once your request has been approved by your Estate Admin</Box>
            </Stack>

            <Text fontSize={"12px"} textAlign="center" mt="12px" borderTop="0.5px solid black" pt="5px" fontFamily="body" color="#424242" fontWeight={"400"}>This access code is only valid for {number} people.
            </Text>
          </ModalBody>

          <ModalFooter>

          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
}
